var _defs, _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVideo = function SvgVideo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f1f2f2;}.cls-2{fill:#bcbec0;}.cls-3{fill:#e1251b;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.43,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 2.1,
    ry: 2.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m33.33,1c.88,0,1.6.72,1.6,1.6v30.8c0,.88-.72,1.6-1.6,1.6H2.53c-.88,0-1.6-.72-1.6-1.6V2.6c0-.88.72-1.6,1.6-1.6h30.8m0-1H2.53C1.09,0-.07,1.16-.07,2.6v30.8c0,1.43,1.16,2.6,2.6,2.6h30.8c1.43,0,2.6-1.16,2.6-2.6V2.6c0-1.43-1.16-2.6-2.6-2.6h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m25.47,17.39l-12.87-7.43c-.47-.27-1.05.07-1.05.61v14.86c0,.54.58.88,1.05.61l12.87-7.43c.47-.27.47-.94,0-1.21Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVideo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/video.b4842856d878166946238beedf7373fe.svg";